import * as React from "react";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON, Circle, Pane, Layer, ControlledLayer} from 'react-leaflet';
import * as rand from './random';
import L, { geoJSON, map, marker, Control } from "leaflet";
import OverpassFrontend from 'overpass-frontend'
import {arrHospitalesAux, arrColegiosAux} from './App'

var arrFamilias = []
var arrHospitales = []
var arrColegios = []
var arrPolicia = []
var arrMercados = []
var arrBomberos = []
var arrPanadería = []

var FamiliaIcon = L.icon({ //add this new icon
  iconUrl: 'familia-ico.png',
  shadowUrl: 'sombra-ico.png',

  iconSize:     [44, 46], // size of the icon
  shadowSize:   [44, 46], // size of the shadow
  iconAnchor:   [22, 48], // point of the icon which will correspond to marker's location
  shadowAnchor: [22, 48],  // the same for the shadow
  popupAnchor:  [0, -50] // point from which the popup should open relative to the iconAnchor
});

for (let i = 0; i < rand.arrFamilias.length; i++) {
    arrFamilias.push([rand.arrFamilias[i].latitud,rand.arrFamilias[i].longitud])
  }
  
  class Familia extends React.Component {
    constructor() {
      super();
      this.state = {
        markers: arrFamilias,
        count: 0
      };
    }
  
    render() {
      return (this.state.markers.map((position, idx) => 
      <Marker key={`marker-${idx}`} position={position} icon={FamiliaIcon}>
      <Popup>
        <span>Familia {idx + 1}. <br/> Easily customizable.</span>
      </Popup>
    </Marker>))
    }
  }
  
  class Hospital extends React.Component {
    constructor() {
      super();
      this.state = {
        markers: arrHospitalesAux,
        count: 0
      };
    }
  
    render() {
      return (this.state.markers.map((position, idx) => 
      <Marker key={`hospital-${idx}`} position={position}>
      <Popup>
        <span>Hospital {idx + 1}. <br/> Easily customizable.</span>
      </Popup>
    </Marker>))
    }
  }
  
  class Escuela extends React.Component {
    constructor() {
      super();
      this.state = {
        markers: arrColegiosAux,
        count: 0
      };
    }
  
    render() {
      console.log('colegio' + arrColegiosAux)
      return (this.state.markers.map((position, idx) => 
      <Marker key={`escuela-${idx}`} position={position}>
      <Popup>
        <span>Escuela {idx + 1}. <br/> Easily customizable.</span>
      </Popup>
    </Marker>))
    }
  }

  const overpassFrontend = new OverpassFrontend('//overpass-api.de/api/interpreter')

  overpassFrontend.BBoxQuery(
    'nwr[amenity=hospital]',
    { minlat: rand.Ciudad.latitud - 0.01, maxlat: rand.Ciudad.latitud + 0.01, minlon: rand.Ciudad.longitud - 0.01, maxlon: rand.Ciudad.longitud + 0.01 },
    {
      properties: OverpassFrontend.ALL
    },
    function (err, result) {
      arrHospitales.push(result)
      console.log('* ' + result.tags.name + ' (' + result.id + ')')
      console.log(arrHospitales)
    },
    function (err) {
      if (err) { console.log(err) }
    },
  )

  overpassFrontend.BBoxQuery(
    'nwr[amenity=school]',
    { minlat: rand.Ciudad.latitud - 0.01, maxlat: rand.Ciudad.latitud + 0.01, minlon: rand.Ciudad.longitud - 0.01, maxlon: rand.Ciudad.longitud + 0.01 },
    {
      properties: OverpassFrontend.ALL
    },
    function (err, result) {
      arrColegios.push(result)
      console.log('* ' + result.tags.name + ' (' + result.id + ')')
      //.then
    },
    function (err) {
      if (err) { console.log(err) }
    },
  )

  overpassFrontend.BBoxQuery(
    'nwr[amenity=police]',
    { minlat: rand.Ciudad.latitud - 0.01, maxlat: rand.Ciudad.latitud + 0.01, minlon: rand.Ciudad.longitud - 0.01, maxlon: rand.Ciudad.longitud + 0.01 },
    {
      properties: OverpassFrontend.ALL
    },
    function (err, result) {
      arrPolicia.push(result)
      console.log('* ' + result.tags.name + ' (' + result.id + ')')
      //.then
    },
    function (err) {
      if (err) { console.log(err) }
    },
  )

  overpassFrontend.BBoxQuery(
    'nwr[shop=supermarket]',
    { minlat: rand.Ciudad.latitud - 0.01, maxlat: rand.Ciudad.latitud + 0.01, minlon: rand.Ciudad.longitud - 0.01, maxlon: rand.Ciudad.longitud + 0.01 },
    {
      properties: OverpassFrontend.ALL
    },
    function (err, result) {
      arrMercados.push(result)
      console.log('* ' + result.tags.name + ' (' + result.id + ')')
      //.then
    },
    function (err) {
      if (err) { console.log(err) }
    },
  )

  overpassFrontend.BBoxQuery(
    'nwr[shop=bakery]',
    { minlat: rand.Ciudad.latitud - 0.01, maxlat: rand.Ciudad.latitud + 0.01, minlon: rand.Ciudad.longitud - 0.01, maxlon: rand.Ciudad.longitud + 0.01 },
    {
      properties: OverpassFrontend.ALL
    },
    function (err, result) {
      arrPanadería.push(result)
      console.log('* ' + result.tags.name + ' (' + result.id + ')')
      //.then
    },
    function (err) {
      if (err) { console.log(err) }
    },
  )


  overpassFrontend.BBoxQuery(
    'nwr[amenity=fire_station]',
    { minlat: rand.Ciudad.latitud - 0.01, maxlat: rand.Ciudad.latitud + 0.01, minlon: rand.Ciudad.longitud - 0.01, maxlon: rand.Ciudad.longitud + 0.01 },
    {
      properties: OverpassFrontend.ALL
    },
    function (err, result) {
      arrBomberos.push(result)
      console.log('* ' + result.tags.name + ' (' + result.id + ')')
      //.then
    },
    function (err) {
      if (err) { console.log(err) }
    },
  )

export {Familia, Escuela, Hospital, arrHospitales, arrColegios, arrPolicia, arrBomberos, arrMercados, arrPanadería}